import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShield: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield, security, protection"><path d="M13.1859 2.35455C12.4161 2.09796 11.5839 2.09796 10.8141 2.35455L4.88037 4.33247C3.75743 4.70678 3 5.75767 3 6.94135V11.9122C3 14.6495 4.18351 16.6699 5.85876 18.2595C7.5058 19.8223 9.65956 20.9973 11.6439 22.0678C11.8662 22.1877 12.1338 22.1877 12.3561 22.0678C14.3404 20.9973 16.4942 19.8223 18.1412 18.2595C19.8165 16.6699 21 14.6495 21 11.9122V6.94135C21 5.75767 20.2426 4.70678 19.1196 4.33247L13.1859 2.35455Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShield;
